import React from "react";
import { Link } from "react-router-dom";
import { Button, Segment, Header } from "semantic-ui-react";

const CuentaListEmpty = () => {
  return (
    <>
      <Segment textAlign="center">
        <Header as="h4" color="blue" style={{ margin: "1em" }}>
          No cuenta con cuentas de ahorro.
        </Header>
        <Button
          as={Link}
          to="/aperturar-cuenta"
          basic
          color="blue"
          content="Aperture aquí"
        />
      </Segment>
    </>
  );
};

export default CuentaListEmpty;
